// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selection-control--SxS53:hover:not(.is-disabled,.is-readonly) .unchecked-icon--rZqO5 [stroke]{stroke:#5a6272}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selection-control": "selection-control--SxS53",
	"unchecked-icon": "unchecked-icon--rZqO5"
};
export default ___CSS_LOADER_EXPORT___;
